//import "./Home.scss";
import "../../App.scss";
import "../../assets/css/libraries.css";
import "../../assets/css/style.css";
import "../../assets/images/logo/logo-light-small.png";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar.jsx";
import ActivePatientBar from "../PatientSearch/ActivePatientBar";
// import NavLogo from "../../assets/images/logo/NavLogo.png";
// import NavLogoFooter from "../../assets/images/logo/NavLogoFooter_new.svg";
import NavLogoFooter from "../../assets/images/logo/NavLogo_footer_white.svg";
import RateCards from "./../../components/Landing/RateCards";
import { Box, Grid, Typography } from "@mui/material";

function Layout({ children, setSearchText, home }) {
  const [open, setOpen] = useState(0);
  const [search, setSearch] = useState("");

  const history = useHistory();

  return (
    <div className="wrapper" style={{ minHeight: "100dvh" }}>
      <Navbar />
      <ActivePatientBar />
      {/* {children} */}
      <main style={{ flex: 1 }}>{children}</main>
      <div className="footer">
        <Box
          className="footer-primary"
          sx={{
            px: "30px", // 30px left and right padding
          }}
        >
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} md={4}>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: { xs: "center", md: "left", color: "#F4F4F4" },
                }}
              >
                Version 1.0
              </Typography> */}
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography
                variant="body2"
                sx={{ textAlign: "center", color: "#F4F4F4" }}
              >
                Powered by
                {/* HlthTek Optimus Pvt. Ltd. */}
                <img
                  src={NavLogoFooter}
                  className="logo-dark logo-img"
                  alt="logo"
                  height="32px"
                  style={{
                    // paddingBottom: "3px",
                    // paddingTop: "5px",
                    marginLeft: "5px",
                  }}
                />
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              {/* <div className="d-flex justify-content-end">
                <ul className="social-icons list-unstyled mb-0">
                  <li>
                    <a href="#">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                </ul>
              </div> */}
            </Grid>
          </Grid>
        </Box>
      </div>
      {/* <button id="scrollTopBtn">
        <i className="fas fa-long-arrow-alt-up"></i>
      </button> */}

      <Helmet>
        {/* <script src="../../assets/js/jquery-3.5.1.min.js"></script>
        <script src="../../assets/js/plugins.js"></script>
        <script src="../../assets/js/main.js"></script> */}
        <script
          src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"
          type="text/javascript"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.15.3/css/all.css"
        />

        <link href="../../assets/images/logo/logo-light-small.png" rel="icon" />
      </Helmet>
    </div>
  );
}
export default Layout;
